import React, { memo } from 'react';
import { CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton, Section } from './Shared';
import { Mandala } from './HealingIcons';
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-42" data-mp="vkjpy1xhdc9n">
      <div className="relative overflow-hidden rounded-3xl border border-brand-gold/55 bg-brand-paper p-7 text-center shadow-[0_18px_48px_rgba(34,54,70,0.12)] md:p-12" data-id="element-43" data-mp="qn9v26rbo8ef">
        <Mandala className="absolute -right-20 -top-20 h-64 w-64 opacity-10" color="#B88A35" data-id="element-44" data-mp="mjlj7bvnqqnd" />
        <Mandala className="absolute -bottom-24 -left-24 h-64 w-64 opacity-10" color="#2E5946" data-id="element-45" data-mp="cnik6ew3r84n" />
        <div className="relative" data-id="element-46" data-mp="7p78rzq5spkb">
          <h2 className="font-display text-3xl font-bold text-brand-ink md:text-5xl" data-id="element-47" data-mp="7pyu8hq1l6wv">
            Hay dos versiones de vos en este momento.
          </h2>
          <div className="mx-auto mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-brand-text md:text-lg" data-id="element-48" data-mp="221x48lw6e6tt">
            <p data-id="element-49" data-mp="3529b7m7bcqxe">
              Una que cierra esta página y la próxima sesión sigue dependiendo
              únicamente de su memoria, sin una herramienta visual que respalde
              cada punto, sin un sistema de consulta rápida y sin el material
              técnico que sus pacientes merecen ver.
            </p>
            <p className="font-semibold text-brand-forest" data-id="element-50" data-mp="303y43j8ekuiv">
              Y otra que decide que hoy es el día en que su práctica de
              digitopuntura cambia para siempre.
            </p>
            <p className="font-serif text-xl italic text-brand-goldDark" data-id="element-51" data-mp="3srk7aqdpxx57">
              La pregunta no es si podés pagarlo.
              <br data-id="element-52" data-mp="3e14k561qsf4e" />
              La pregunta es cuántas sesiones más vas a trabajar sin el sistema
              visual que tu práctica necesita.
            </p>
          </div>
          <div className="mx-auto mt-10 max-w-md rounded-2xl border-2 border-brand-forest bg-brand-paper p-6 shadow-lg" data-id="element-53" data-mp="akxit66sutys">
            <span className="-mt-10 inline-block rounded-full bg-brand-forest px-3 py-1 text-[10px] font-bold tracking-wide text-brand-paper" data-id="element-54" data-mp="ffa3fjk0ibc4">
              MÁS ELEGIDO
            </span>
            <h3 className="mt-4 font-serif text-xl font-bold text-brand-ink" data-id="element-55" data-mp="kavxk7eaxndf">
              EL BOTIQUÍN ANCESTRAL™
            </h3>
            <p className="mt-2 font-serif text-4xl font-bold text-brand-purple" data-id="element-56" data-mp="b9ek6wsa3zsf">
              $27.990 ARS
            </p>
            <p className="mt-4 text-sm leading-relaxed text-brand-muted" data-id="element-57" data-mp="6al7h6ktgctb">
              Ebook Principal + 6 Bonos · 60 páginas + material completo. La
              caja de herramientas visual de digitopuntura clínica más completa
              en español.
            </p>
            <CTAButton fullWidth className="mt-6 py-3.5 text-sm" data-id="element-58" data-mp="3oob0ohnqgral">
              → QUIERO MI BOTIQUÍN ANCESTRAL $27.990
            </CTAButton>
          </div>
          <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-brand-muted md:text-sm" data-id="element-59" data-mp="3joon273zt919">
            <span className="inline-flex items-center gap-1" data-id="element-60" data-mp="3es7wz7d8gklj">
              <LockKeyholeIcon className="h-4 w-4" data-id="element-61" data-mp="1u716x0xwwvj9" />
              Pago 100% seguro
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-62" data-mp="1z5vx4ny7lmde">
              <ZapIcon className="h-4 w-4" data-id="element-63" data-mp="246jnr8ij0173" />
              Acceso en 5 minutos
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-64" data-mp="287lojts3clb6">
              <ShieldCheckIcon className="h-4 w-4" data-id="element-65" data-mp="2872et0clh388" />
              Garantía 7 días
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-66" data-mp="1bjflvceqc2zj">
              <CreditCardIcon className="h-4 w-4" data-id="element-67" data-mp="1ghqzly85axn1" />
              Mercado Pago | Tarjeta
            </span>
          </div>
          <div className="mt-8 rounded-2xl border border-brand-green/20 bg-brand-surfaceLight/55 p-5 text-left text-sm leading-relaxed text-brand-text md:text-center" data-id="element-68" data-mp="1kgq27c6emibb">
            <p data-id="element-69" data-mp="srwl7c86h10o">
              <strong className="text-brand-ink" data-id="element-70" data-mp="sqbr1nprzk3c">P.D.:</strong> Si tenés dudas,
              escribinos a{' '}
              <a className="font-semibold text-brand-forest underline-offset-2 hover:underline" href="mailto:soportelumenakasha@gmail.com" data-id="element-71" data-mp="wr5hanqoxaze">
                soportelumenakasha@gmail.com
              </a>{' '}
              o a{' '}
              <a className="font-semibold text-brand-forest underline-offset-2 hover:underline" href="https://instagram.com/lumen.akasha" data-id="element-72" data-mp="ney89cga7ukh">
                @lumen.akasha
              </a>
              . Te respondemos hoy.
            </p>
            <p className="mt-3 italic text-brand-goldDark" data-id="element-73" data-mp="rg9qgwwttdin">
              El precio de lanzamiento sube pronto. El mejor momento para tener
              tu herramienta clínica visual de digitopuntura es ahora.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}